module.exports = __webpack_public_path__ + "static/Vietnam-09e7d961e9b29a0a0ebf3d3535b5c7c5.jpg";